import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgxMaskModule } from 'ngx-mask';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { TextMaskModule } from 'angular2-text-mask';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CardActivationComponent } from './components/card-activation/card-activation.component';
import { ConfigService } from './services/config.service';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule, Dialog } from 'primeng/dialog';
import { InputUppercaseDirective } from './directives/input-uppercase.directive';
import { LoginComponent } from './components/login/login.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RegistrationComponent } from './components/registration/registration.component';
import { ThanksComponent } from './components/thanks/thanks.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { CreatePasswordComponent } from './components/create-password/create-password.component';
import { environment } from 'src/environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    CardActivationComponent,
    InputUppercaseDirective,
    LoginComponent,
    RegistrationComponent,
    SpinnerComponent,
    ThanksComponent,
    FooterComponent,
    HeaderComponent,
    CreatePasswordComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    DropdownModule,
    DialogModule,
    FormsModule,
    HttpClientModule,
    NgxMaskModule.forRoot(),
    ProgressSpinnerModule,
    ReactiveFormsModule,
    TextMaskModule,
  ],
  providers: [{
    provide: APP_INITIALIZER,
    useFactory: ConfigLoader,
    deps: [ConfigService],
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function ConfigLoader(configService: ConfigService) {
  // this factory need to return a function (that return a promise)
  return () => configService.load(environment.configFile);
}
